import * as React from 'react';
import { IconProps } from '../types';

const IcStorage = (props: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    {...props}
  >
    <path
      d='M9.99998 5.57854C9.09509 5.57854 1.15735 5.51664 1.15735 3.36788C1.15735 1.21913 9.09509 1.15723 9.99998 1.15723C10.9049 1.15723 18.8426 1.21913 18.8426 3.36788C18.8426 5.51664 10.9049 5.57854 9.99998 5.57854ZM2.32752 3.36788C2.86692 3.78644 5.45561 4.47321 9.99998 4.47321C14.5444 4.47321 17.133 3.78644 17.6724 3.36788C17.133 2.94933 14.5444 2.26256 9.99998 2.26256C5.45561 2.26256 2.86692 2.94933 2.32752 3.36788Z'
      fill={props?.fill ?? '#9747FF'}
    />
    <path
      d='M9.99998 9.99965C9.09509 9.99965 1.15735 9.93775 1.15735 7.78899C1.15735 7.48392 1.40494 7.23633 1.71001 7.23633C1.99371 7.23633 2.22731 7.45002 2.25899 7.72562C2.59943 8.13312 5.21538 8.89432 9.99998 8.89432C14.7846 8.89432 17.4005 8.13312 17.741 7.72562C17.7727 7.45002 18.0062 7.23633 18.2899 7.23633C18.595 7.23633 18.8426 7.48392 18.8426 7.78899C18.8426 9.93775 10.9049 9.99965 9.99998 9.99965ZM17.7373 7.78826C17.7373 7.78899 17.7373 7.78899 17.7373 7.78826V7.78826ZM2.26268 7.78826C2.26268 7.78899 2.26268 7.78899 2.26268 7.78826V7.78826Z'
      fill={props?.fill ?? '#9747FF'}
    />
    <path
      d='M9.99998 14.421C9.09509 14.421 1.15735 14.3591 1.15735 12.2104C1.15735 11.9053 1.40494 11.6577 1.71001 11.6577C1.99371 11.6577 2.22731 11.8714 2.25899 12.147C2.59943 12.5545 5.21538 13.3157 9.99998 13.3157C14.7846 13.3157 17.4005 12.5545 17.741 12.147C17.7727 11.8714 18.0062 11.6577 18.2899 11.6577C18.595 11.6577 18.8426 11.9053 18.8426 12.2104C18.8426 14.3591 10.9049 14.421 9.99998 14.421ZM17.7373 12.2096C17.7373 12.2104 17.7373 12.2104 17.7373 12.2096V12.2096ZM2.26268 12.2096C2.26268 12.2104 2.26268 12.2104 2.26268 12.2096V12.2096Z'
      fill={props?.fill ?? '#9747FF'}
    />
    <path
      d='M9.99998 18.8427C9.09509 18.8427 1.15735 18.7808 1.15735 16.632V3.36809C1.15735 3.06302 1.40494 2.81543 1.71001 2.81543C2.01508 2.81543 2.26268 3.06302 2.26268 3.36809V16.5724C2.61712 16.9821 5.23233 17.7374 9.99998 17.7374C14.7676 17.7374 17.3828 16.9821 17.7373 16.5724V3.36809C17.7373 3.06302 17.9849 2.81543 18.2899 2.81543C18.595 2.81543 18.8426 3.06302 18.8426 3.36809V16.632C18.8426 18.7808 10.9049 18.8427 9.99998 18.8427Z'
      fill={props?.fill ?? '#9747FF'}
    />
    <path
      d='M4.84174 12.2106C5.24872 12.2106 5.57863 11.8807 5.57863 11.4737C5.57863 11.0667 5.24872 10.7368 4.84174 10.7368C4.43477 10.7368 4.10486 11.0667 4.10486 11.4737C4.10486 11.8807 4.43477 12.2106 4.84174 12.2106Z'
      fill={props?.fill ?? '#9747FF'}
    />
    <path
      d='M4.84174 7.7892C5.24872 7.7892 5.57863 7.45929 5.57863 7.05232C5.57863 6.64534 5.24872 6.31543 4.84174 6.31543C4.43477 6.31543 4.10486 6.64534 4.10486 7.05232C4.10486 7.45929 4.43477 7.7892 4.84174 7.7892Z'
      fill={props?.fill ?? '#9747FF'}
    />
    <path
      d='M4.84174 16.632C5.24872 16.632 5.57863 16.3021 5.57863 15.8951C5.57863 15.4881 5.24872 15.1582 4.84174 15.1582C4.43477 15.1582 4.10486 15.4881 4.10486 15.8951C4.10486 16.3021 4.43477 16.632 4.84174 16.632Z'
      fill={props?.fill ?? '#9747FF'}
    />
  </svg>
);

export default IcStorage;
